var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collapse-item"},[_c('div',{staticClass:"title",on:{"click":_vm.toggle}},[_vm._v(_vm._s(_vm.title))]),(_vm.open)?_c('div',{staticClass:"content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }